import { useTransitionId } from '@confluence/route-manager/entry-points/RouteState';

const RELEASE_UNUSED_DELAY_TIME = 10000; // 10 sec

const ssredMacros = new Map<string, HTMLElement>();
const usedMacros = new Set<string>();

/**
 * Clean up the internal data structure that holds references to DOM elements picked up by `collectSSRedLegacyMacro`,
 * allowing garbage collector to collect those element.
 * Expected to be called on transition, sinse the store elements no longer supposed to be used.
 */
export function releaseSSRedLegacyMacros() {
	ssredMacros.clear();
}

/**
 * Release references for those elements that are not been used during the render cycle.
 */
export function releaseUnusedSSRedLegacyMacrosWithDelay() {
	setTimeout(releaseUnused, RELEASE_UNUSED_DELAY_TIME);
}

function releaseUnused() {
	for (const macroId of ssredMacros.keys()) {
		if (!usedMacros.has(macroId)) ssredMacros.delete(macroId);
	}
}

/**
 * The hook takes macroId as an input, and returns corresponding DOM element representing SSRed macro.
 * Will only return element for initial load, since after transition it makes no sense to use SSRed output.
 */
export function useSSRedLegacyMacroElement(macroId: string) {
	const transitionId = useTransitionId();
	usedMacros.add(macroId);
	return !transitionId ? ssredMacros.get(macroId) : undefined;
}

export function collectSSRedLegacyMacro(macroId: string) {
	if (!ssredMacros.has(macroId)) {
		const ele = document.querySelector(`[data-fabric-macro="${macroId}"][data-skate-created]`);
		if (ele) {
			ssredMacros.set(macroId, ele as HTMLElement);
		}
	}
}
